export enum AllowedTabTypes {
  editorial = 'editorial',
  fixtures = 'fixtures',
  lineups = 'lineups',
  sportstable = 'sportstable',
  statistics = 'statistics',
}
export interface LayoutTab {
  kind: ['layout', 'tab']
  content?: any[]
  name: string
  type: AllowedTabTypes
}

export interface LayoutTabsProps {
  kind: ['layout', 'tabs2']
  content: LayoutTab[]
  activeTabIndex: number
}

export interface ScrollableTabProps {
  tab: any
  tabIndex: number
  isActive: boolean
  updateActiveTab: (index: number) => void
}

export interface ScrollableTabsProps {
  tabs: string[]
  activeTabIndex: number
  updateActiveTab: (index: number) => void
}
